import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const PoliticaPrivacidad = () => {
  return (
    <div className="min-h-screen bg-[#020617] text-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-indigo-400 hover:text-indigo-300 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-invert prose-slate max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Responsable del tratamiento</h2>
            <ul className="text-slate-300 space-y-2 list-none pl-0">
              <li><strong className="text-white">Identidad:</strong> Antonio Jesús Oliver García — DATYON</li>
              <li><strong className="text-white">NIF:</strong> 15480316M</li>
              <li><strong className="text-white">Domicilio:</strong> Calle de Francisco García el Maestro, 7, Derecha, 30320 Fuente Álamo, Murcia, España</li>
              <li><strong className="text-white">Correo electrónico:</strong> info@datyon.com</li>
              <li><strong className="text-white">Teléfono:</strong> 672 972 514</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Finalidad del tratamiento de datos</h2>
            <p className="text-slate-300 leading-relaxed">
              Los datos personales recogidos a través del formulario de contacto de este sitio web serán tratados 
              con las siguientes finalidades:
            </p>
            <ul className="text-slate-300 space-y-2 mt-4 list-disc pl-6">
              <li>Responder a las consultas enviadas a través del formulario de contacto.</li>
              <li>Gestionar comunicaciones profesionales relacionadas con los servicios ofrecidos por DATYON.</li>
              <li>Mantener el contacto necesario para la prestación de servicios solicitados.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Base legal del tratamiento</h2>
            <p className="text-slate-300 leading-relaxed">
              La base legal para el tratamiento de sus datos es el <strong className="text-white">consentimiento del usuario</strong>, 
              otorgado al enviar voluntariamente sus datos a través del formulario de contacto de este sitio web.
            </p>
            <p className="text-slate-300 leading-relaxed mt-4">
              El envío del formulario de contacto implica que el usuario ha leído y acepta esta Política de Privacidad.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Datos personales recogidos</h2>
            <p className="text-slate-300 leading-relaxed">
              A través del formulario de contacto se recogen los siguientes datos personales:
            </p>
            <ul className="text-slate-300 space-y-2 mt-4 list-disc pl-6">
              <li>Nombre</li>
              <li>Nombre de la empresa</li>
              <li>Correo electrónico</li>
              <li>Teléfono (opcional)</li>
              <li>Mensaje o consulta</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Conservación de los datos</h2>
            <p className="text-slate-300 leading-relaxed">
              Los datos personales proporcionados se conservarán únicamente durante el tiempo necesario para 
              responder a la consulta realizada y gestionar la comunicación derivada de la misma.
            </p>
            <p className="text-slate-300 leading-relaxed mt-4">
              Una vez finalizada la gestión, los datos serán eliminados salvo que exista una obligación legal 
              de conservación o el usuario haya dado su consentimiento para otros fines.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Destinatarios de los datos</h2>
            <p className="text-slate-300 leading-relaxed">
              Los datos personales no serán cedidos a terceros salvo obligación legal. No se realizan 
              transferencias internacionales de datos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">7. Derechos del usuario</h2>
            <p className="text-slate-300 leading-relaxed">
              El usuario tiene derecho a:
            </p>
            <ul className="text-slate-300 space-y-2 mt-4 list-disc pl-6">
              <li><strong className="text-white">Acceso:</strong> Conocer qué datos personales estamos tratando.</li>
              <li><strong className="text-white">Rectificación:</strong> Solicitar la corrección de datos inexactos.</li>
              <li><strong className="text-white">Supresión:</strong> Solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
              <li><strong className="text-white">Limitación:</strong> Solicitar la limitación del tratamiento en determinadas circunstancias.</li>
              <li><strong className="text-white">Oposición:</strong> Oponerse al tratamiento de sus datos por motivos relacionados con su situación particular.</li>
              <li><strong className="text-white">Portabilidad:</strong> Recibir los datos en un formato estructurado y de uso común.</li>
            </ul>
            <p className="text-slate-300 leading-relaxed mt-4">
              Para ejercer estos derechos, el usuario podrá contactar con el responsable del tratamiento a través de:
            </p>
            <p className="text-indigo-400 mt-2">
              <a href="mailto:info@datyon.com" className="hover:text-indigo-300 transition-colors">info@datyon.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">8. Derecho a reclamar</h2>
            <p className="text-slate-300 leading-relaxed">
              Si el usuario considera que el tratamiento de sus datos personales infringe la normativa, 
              tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD): 
              <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-indigo-400 hover:text-indigo-300 ml-1">www.aepd.es</a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">9. Seguridad de los datos</h2>
            <p className="text-slate-300 leading-relaxed">
              El responsable del tratamiento ha adoptado las medidas técnicas y organizativas necesarias 
              para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, 
              tratamiento o acceso no autorizado.
            </p>
          </section>

          <p className="text-slate-500 text-sm mt-12">
            Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;
